import React, { useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import { Input, Typography, Button, Icon } from 'antd';
import { useTranslation } from 'react-i18next';
import generatePath from '~settings/routing';
import { useHistory } from 'react-router-dom';

const { Title } = Typography;
const useStyles = makeStyles(
  theme => ({
    formik: {
      width: '480px',

      '& > *:not(:first-child)': {
        width: '100%',
        marginTop: 16,
      },
    },
    errText: {
      textAlign: 'left',
      color: theme.colors.red6,
    },
    inputErr: {
      borderColor: theme.colors.red6,

      '&:hover': {
        borderColor: theme.colors.red6,
        boxShadow: 'none !important',
      },
    },
    emailText: {
      marginTop: '12px !important',
      marginBottom: '40px !important',
    },
    passwordWrapper: {
      position: 'relative',
    },
    forgetPassword: {
      position: 'absolute',
      top: 10,
      right: 16,
      cursor: 'pointer',
      zIndex: 1,
      fontSize: '14px',
      lineHeight: '22px',
      color: '#38B2A6',
    },
    openEmailText: {
      color: '#f25203',
      textDecoration: 'underline',
    },
    title: {
      lineHeight: '38px !important',
      margin: '0 !important',
      opacity: 0.85,
    },
    backbtn: {
      marginBottom: 100,
      padding: 0,
      color: theme.colors.bodyColor,
      border: 0,
      shadow: 'none',
    },
  }),
  { name: 'LoginForSetEmailPassword' },
);

export const AgentLoginbyEmail = ({ loginEmail, handleNextContent, handleBackEvent, loading }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const history = useHistory();
  const [password, setPassword] = useState();
  const [emailErrTip, setEmailErrMessage] = useState();
  const [isDisableUser, setDisaledUser] = useState(false);
  const handelChangePassword = e => {
    const value = e?.target?.value;
    setPassword(value);
    setDisaledUser(false);
    setEmailErrMessage();
  };

  const handelValidateTriggerPassword = value => {
    if (!value) {
      setEmailErrMessage(t('this_part_cannot_be_empty'));
      return;
    }

    if (value?.length < 8) {
      setEmailErrMessage(t('landlord.auth.login.format_error.password'));
      return;
    }
  };

  const handleClickContinue = () => {
    if (loginEmail && !emailErrTip) {
      handleNextContent({ email: loginEmail, password }, setEmailErrMessage);
    }
  };
  const handleClickForgetPassword = () => {
    history.push(generatePath('resetAgentPassword', { email: loginEmail }));
  };
  return (
    <div className={classes.formik}>
      <Button ghost className={classes.backbtn} onClick={handleBackEvent}>
        <Icon type="arrow-left" />
        {t('back')}
      </Button>
      <Title level={2} className={classes.title}>
        {t('log_in')}
      </Title>
      <Typography className={classes.emailText}>
        {t('enter_password_for_email', { email: loginEmail })}
      </Typography>
      <div className={classes.passwordWrapper}>
        <span
          className={classes.forgetPassword}
          role="presentation"
          onClick={handleClickForgetPassword}
        >
          {t('landlord.log_in.main.link.forget_password')}
        </span>
        <Input
          size="large"
          type="password"
          placeholder={t('password')}
          onChange={handelChangePassword}
          onBlur={e => {
            handelValidateTriggerPassword(e?.target?.value);
          }}
          style={{ paddingRight: 130 }}
          className={emailErrTip ? classes.inputErr : ''}
        />
        <Typography className={classes.errText} style={{ marginTop: 4 }}>
          {emailErrTip}
          {isDisableUser && (
            <a target="_blank" href="mailto:contact@student.com" rel="noreferrer">
              <span className={classes.openEmailText}>{t('login_error_email_us')}</span>
            </a>
          )}
        </Typography>
      </div>
      <Button type="primary" size="large" loading={loading} onClick={handleClickContinue}>
        {t('continue')}
      </Button>
    </div>
  );
};

AgentLoginbyEmail.propTypes = {
  loginEmail: PropTypes.string.isRequired,
  history: PropTypes.object,
  handleNextContent: PropTypes.func.isRequired,
  handleBackEvent: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default AgentLoginbyEmail;
